module.exports = ".container {\n  max-width: 330px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = 567
// module chunks = 1